export default __webpack_public_path__ + "static/media/3Satisfaccion.c9598d66.svg";